import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import cx from 'classnames'
import AdditionalPatientRow from './AdditionalPatientRow'
import Attribution from './Attribution'
import { choosePhoneNumberFormatter } from '../../../services/formatters'
import css from '../../sitewide/ScheduleBox/styles.css'
import styles from './styles.css'

class BookingPatientRow extends Component {
  state = {
    showAppt: false,
  }

  toggleShowAppt = () => {
    const { showAppt } = this.state
    this.setState({ showAppt: !showAppt })
  }

  render() {
    const { showAppt } = this.state
    const { openDialog, patient } = this.props
    const formatPhoneNumberUS = choosePhoneNumberFormatter('US')
    const caretStyles = cx(styles.caret, styles.caretOuter, {
      [styles.activePatient]: showAppt,
    })
    const innerCaret = cx(styles.caret, styles.caretInner)
    const firstNameColumn = cx(css.cell, styles.firstNameColumn)
    const lastNameColumn = cx(css.cell, styles.lastNameColumn)
    const guardianNameColumn = cx(css.cell, styles.guardianNameColumn)
    const phoneColumn = cx(css.cell, styles.phoneColumn)
    const emailColumn = cx(css.cell, styles.emailColumn)
    const attributionColumn = cx(css.cell, styles.attributionColumn)
    const createdColumn = cx(css.cell, styles.createdColumn)
    // concierge is such a specific word that this regex just looks for it anywhere
    // regardless of capitalization or if it's a substring, has punctuation, etc.
    const conciergePatient = patient.message
      ? /concierge/i.test(patient.message)
      : false

    return (
      <div className={styles.patientRow}>
        <div
          className={styles.mainPatientRow}
          onClick={this.toggleShowAppt}
          role="button"
          tabIndex="-1"
        >
          {conciergePatient && <div className={styles.conciergeIcon}>C</div>}
          <div className={caretStyles}>
            <span className={innerCaret} />
          </div>
          <li className={css.bodyRow}>
            <span className={firstNameColumn}>{patient.first_name}</span>
            <span className={lastNameColumn}>{patient.last_name}</span>
            <span className={guardianNameColumn}>
              {patient.guardian_name || '-'}
            </span>
            <span className={phoneColumn}>
              {formatPhoneNumberUS(patient.phone)}
            </span>
            <span className={emailColumn}>{patient.email}</span>
            <span className={attributionColumn}>
              {patient.attribution ? (
                <Attribution
                  attribution={patient.attribution}
                  otherAttribution={patient.other_attribution}
                />
              ) : (
                'n/a'
              )}
            </span>
            <span className={createdColumn}>
              <span>{moment(patient.created_at).format('MMMM DD, YYYY')}</span>
            </span>
          </li>
        </div>
        {showAppt && (
          <AdditionalPatientRow openDialog={openDialog} patient={patient} />
        )}
      </div>
    )
  }
}

BookingPatientRow.propTypes = {
  openDialog: PropTypes.func.isRequired,
  patient: PropTypes.object.isRequired,
}

export default BookingPatientRow



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/BookingPatientRow.js